import React from 'react';
import PropTypes from 'prop-types';

import TaskProgressBadge, { computeProgressPercentage } from '../components/TaskProgressBadge';

const TaskProgressColumnBadge = ({ totals, useExecutionDuration }) => (
  <TaskProgressBadge percentage={computeProgressPercentage(totals, useExecutionDuration)} />
);

TaskProgressColumnBadge.propTypes = {
  totals: PropTypes.shape({
    completedCount: PropTypes.number,
    totalCount: PropTypes.number,
    completedDurationMinutes: PropTypes.number,
    totalDurationMinutes: PropTypes.number,
  }),
  useExecutionDuration: PropTypes.bool.isRequired,
};

TaskProgressColumnBadge.defaultProps = {
  totals: undefined,
};

export default TaskProgressColumnBadge;
